import { render, staticRenderFns } from "./searchbar.vue?vue&type=template&id=9924d8d6&"
import script from "./searchbar.vue?vue&type=script&lang=js&"
export * from "./searchbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports